module.exports = __webpack_public_path__ + "img/dropdown.39ee9801.svg";